import React from 'react';

import { TextShimmerLoader } from '../../Shared/components/ShimmerLoaders';
import { LegacyCard } from '../../Shared/components-v2/legacy-card/LegacyCard';

const CardShimmerLoader: React.FC = () => {
  return (
    <LegacyCard>
      <LegacyCard.Content>
        <TextShimmerLoader numLines={2} />
      </LegacyCard.Content>
    </LegacyCard>
  );
};

export default CardShimmerLoader;
